<template>
	<section class="content-section">
		<span class="content-number">{{ number }} /</span>
		<div>
			<h2>{{ title }}</h2>
			<slot />
		</div>
	</section>
</template>

<script setup>
defineProps({ number: { type: String, required: true }, title: { type: String, required: true } });
</script>
